import { render, staticRenderFns } from "./marketingReport.vue?vue&type=template&id=6c5d05d6&scoped=true"
import script from "./marketingReport.vue?vue&type=script&lang=js"
export * from "./marketingReport.vue?vue&type=script&lang=js"
import style0 from "./marketingReport.vue?vue&type=style&index=0&id=6c5d05d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d05d6",
  null
  
)

export default component.exports